import { RootState } from 'redux/reducers'
import { ProductCompareType } from 'types'

export const selectProductComparison = (state: RootState): ProductCompareType[] =>
  state.comparison.productCompare
